// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OugB","left":"styles_left__qLVDT"};